import { OptionTypeBase, CustomerPACSStatus } from "@advapacs/common";
import { axiosInstanceRegion } from "../config/axios-region";
import { useEffect, useState } from "react";
import { IRootState } from "../config/reducers";
import { useSelector } from "react-redux";
import { customerPACSApi } from "@src/config/api";

const useCustomerPacsDropdown = (): Array<OptionTypeBase> => {
  const { isAuthenticated } = useSelector(
    (state: IRootState) => state.loginReducer
  );
  const [customerIds, setCustomerIds] = useState<
    Array<OptionTypeBase> | undefined
  >(undefined);
  useEffect(() => {
    const getCustomerIds = async () => {
      try {
        const params = {
          mode: "dropdown",
          status: CustomerPACSStatus.ACCEPTED,
        };
        const data = await axiosInstanceRegion.get(
          customerPACSApi.GET_CUSTOMER_PACS,
          { params }
        );
        setCustomerIds(
          (data.data.content || []).map((x: { id: string; name: string }) => {
            return {
              label: x.name,
              value: x.id,
            };
          })
        );
      } catch (err) {}
    };
    if (!customerIds && isAuthenticated) getCustomerIds();
  }, [customerIds, isAuthenticated]);

  return customerIds || [];
};

export default useCustomerPacsDropdown;
